import fileDownload from 'js-file-download';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';
import { isEmpty } from 'lodash';

import { Filter, Main } from 'Containers/';
import { toastInfo, toastError } from 'Common/ToastHelper';
import { ReportGeneration } from 'Common/ObjectHelper';
import { base64ToBlob } from 'Common/IEHelper';
import { FileDownloadTypes } from 'Common/Constants/Enumeration/CommonEnum';
import {
  DocumentTypeEnum,
  ExportFileNameEnum,
} from 'Common/Constants/Enumeration/ProcessedDocumentsEnum';

import { ProcessedDocumentsTable } from './components/ProcessedDocumentsTable';
import { getInitialData, getProcessedDocumentData } from './state/page/actions';
import * as CNVersionSelectors from '../controlinformation/state/CNVersionInformation/selectors';
import * as CVNersionActions from '../controlinformation/state/CNVersionInformation/actions';

class ProcessedDocumentsContainer extends Component {
  async componentDidMount() {
    await this.props.getInitialData();
    await this.props.getCNVersionInformation();
    this.parseUrl();
  }

  parseUrl = () => {
    const params = new URLSearchParams(this.props.location.search);
    // The 'view' param should be the Id of a processed document.
    if (params.has('view')) {
      const id = Number(params.get('view'));

      //make sure a document with the given id exists
      let document = this.props.data.find((item) => item.Id === id);

      if (!document) {
        return toastError('Document not found.');
      }

      this.viewProcessedDocument(id);
    }
  };

  cogOptions = [
    {
      icon: 'eye',
      text: 'View',
      handler: (row) => this.viewProcessedDocument(row.Id),
      disabledWhen: (row) => !moment(row.CompletedDT).isValid(),
    },
  ];

  viewProcessedDocument = async (id) => {
    const { CNVersionInformation } = this.props;

    await this.props.getProcessedDocumentData(id);

    const document = this.props.data.find((item) => item.Id === id);

    if (!document.CompletedDT || !moment(document.CompletedDT).isValid()) {
      return toastInfo(`The document isn't done processing.`);
    }

    if (isEmpty(document.Data)) {
      return toastInfo('No data found.');
    }

    switch (document.ProcessedDocumentTypeId) {
      case DocumentTypeEnum.ExportItems:
        fileDownload(
          base64ToBlob(document.Data, FileDownloadTypes.CSV),
          `${ExportFileNameEnum.ExportItems}${document.CreatedDT}.csv`
        );
        break;

      case DocumentTypeEnum.UniversalDataExport:
        fileDownload(
          base64ToBlob(document.Data, FileDownloadTypes.Excel),
          `${ExportFileNameEnum.UniversalDataExport}${document.CreatedDT}.xlsx`
        );
        break;

      case DocumentTypeEnum.ImportedLAPApplicationsReport:
        fileDownload(
          base64ToBlob(document.Data, FileDownloadTypes.Excel),
          `${ExportFileNameEnum.ImportedLAPApplicationsReport}${document.CreatedDT}.xlsx`
        );
        break;

      case DocumentTypeEnum.ImportedDCApplicationsReport:
        fileDownload(
          base64ToBlob(document.Data, FileDownloadTypes.Excel),
          `${ExportFileNameEnum.ImportedDCApplicationsReport}${document.CreatedDT}.xlsx`
        );
        break;
      case DocumentTypeEnum.CNUpdateResultsReport:
        fileDownload(
          base64ToBlob(document.Data, FileDownloadTypes.Excel),
          `CN ${CNVersionInformation.CurrentCNVersion} Update ${document.CreatedDT}.xlsx`
        );
        break;
      case DocumentTypeEnum.CNUpdatePreviewReport:
        fileDownload(
          base64ToBlob(document.Data, FileDownloadTypes.Excel),
          `Projected CN ${CNVersionInformation.LatestCNVersion} Update ${document.CreatedDT}.xlsx`
        );
        break;
      case DocumentTypeEnum.RemoveReplaceIngredientReport:
        fileDownload(
          base64ToBlob(document.Data, FileDownloadTypes.Excel),
          `${ExportFileNameEnum.RemoveReplaceIngredientReport}${document.CreatedDT}.xlsx`
        );
        break;
      default:
        ReportGeneration(
          document.Data,
          `${document.Ref_ProcessedDocumentType.Description} - ${document.CreatedDT}`
        );
        break;
    }
  };

  render() {
    const { loading, data } = this.props;

    return (
      <Fragment>
        <Filter title={'View Processed'} />
        <Main>
          <ProcessedDocumentsTable
            data={data}
            cogOptions={this.cogOptions}
            loading={loading}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { page } = state.ProcessedDocumentsState;
  return {
    loading: page.fetching,
    data: page.data,
    CNVersionInformation: CNVersionSelectors.getCNVersionInformation(state),
  };
};

export const ProcessedDocuments = withRouter(
  connect(mapStateToProps, {
    getInitialData,
    getProcessedDocumentData,
    ...CVNersionActions,
  })(ProcessedDocumentsContainer)
);



// WEBPACK FOOTER //
// ./src/pages/processeddocuments/ProcessedDocuments.js